// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // or getDatabase for Realtime DB

const firebaseConfig = {
  apiKey: "AIzaSyCH0148AUPMHuKVDngMEWThm3eLlwMtT8Y",
  authDomain: "unisferamun.firebaseapp.com",
  projectId: "unisferamun",
  storageBucket: "unisferamun.firebasestorage.app",
  messagingSenderId: "212769996406",
  appId: "1:212769996406:web:da14d7c5dd9bcac5b3a957",
  measurementId: "G-RD1NYPYWLN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Or use getDatabase(app) for Realtime DB

export { db }; 